import { __awaiter } from "tslib";
import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useAemConfig } from '@as-react/common-components';
import { mergeProductPricesToProductLister } from '@as-react/common-utils';
import { POPOVER_ANIMATION_DURATION } from '@as/cotopaxi';
import { MiniPDPMulti } from '../components/product-detail/mini-pdp/MiniPDPMulti';
import ProductsAPI from '../api/ProductsAPI';
import ProductDetailAPI from '../api/ProductDetailAPI';
import DeliveryPromiseAPI from '../api/DeliveryPromiseAPI';
import { makeGetWishListProducts } from '../redux/wishList/selectors/WishListSelectors';
import { wishListActions } from '../redux/wishList/actions/WishListActions.creators';
import { basketActions } from '../redux/basket/actions/BasketActions.creators';
import { ProductAddToBasketLocations } from '../enums/ActionEnums';
const MiniPDPMultiContainer = ({ popoverTitle, title, onClose, productIds, cdnSettings, extensiveCarouselImages = [], isOpen, productsInfo = [], isPDP = false, mainWebshopId, }) => {
    const { defaultRequestParams, servicesEndpoint, authenticationConfig } = useAemConfig();
    const [shouldRender, setShouldRender] = useState(isPDP);
    const [products, setProducts] = useState([]);
    const [deliveryPromise, setDeliveryPromise] = useState(undefined);
    const [totalPrice, setTotalPrice] = useState(undefined);
    const dispatch = useDispatch();
    const wishlistProducts = useSelector(makeGetWishListProducts());
    const onWishListToggle = (wishListProduct) => dispatch(wishListActions.toggleProduct(wishListProduct));
    const onAddToBasket = (basketProducts) => dispatch(basketActions.createAddBulkAction(basketProducts, ProductAddToBasketLocations.MINI_PDP_SOP_THE_LOOK, isPDP ? productsInfo.length : products.length));
    const _onClose = () => {
        setTimeout(() => {
            onClose();
        }, POPOVER_ANIMATION_DURATION);
    };
    const fetchProducts = () => __awaiter(void 0, void 0, void 0, function* () {
        if (!(productIds === null || productIds === void 0 ? void 0 : productIds.length))
            return;
        try {
            const productsData = yield Promise.all(productIds.map(product => {
                var _a;
                return ProductsAPI.getSingleProductData(servicesEndpoint, defaultRequestParams.mainWebshop, defaultRequestParams.anaLang, defaultRequestParams.language, defaultRequestParams.shopId, product.productCode, product.productColour, (_a = product.fallbackProducts) === null || _a === void 0 ? void 0 : _a.map(fallbackProduct => ({
                    productCode: fallbackProduct.productCode,
                    productColor: fallbackProduct.productColour,
                })), true);
            })).then(result => result.filter(Boolean));
            const productsPriceData = yield ProductDetailAPI.getAllProductDetailPriceByProductId(productsData.map(product => product.productId), servicesEndpoint, defaultRequestParams);
            const mergedProducts = productsData
                .map((product, i) => mergeProductPricesToProductLister(product, productsPriceData[i]))
                .map(item => (Object.assign(Object.assign({}, item), { colours: item.colours.sort(color => (color.colourId === item.colourId ? -1 : 1)) })));
            setProducts(mergedProducts);
            setShouldRender(true);
        }
        catch (_a) { }
    });
    const fetchDeliveryPromise = (items) => __awaiter(void 0, void 0, void 0, function* () {
        if (!items.length) {
            setDeliveryPromise(undefined);
            return;
        }
        try {
            const deliveryPromiseData = yield DeliveryPromiseAPI.getBulkDeliveryPromise(items.map(item => ({ colorId: item.colorId, productId: item.product.productId, skuId: item.sku })), servicesEndpoint, authenticationConfig);
            const latestDeliveryPromise = deliveryPromiseData
                .map(item => (Object.assign(Object.assign({}, item), { deliveryDateTo: new Date(item.deliveryDateTo).getTime() })))
                .sort((a, b) => b.deliveryDateTo - a.deliveryDateTo)[0];
            setDeliveryPromise(latestDeliveryPromise);
        }
        catch (_a) { }
    });
    const fetchTotalPrice = (items) => __awaiter(void 0, void 0, void 0, function* () {
        if (!items.length) {
            setTotalPrice(undefined);
            return;
        }
        try {
            const data = yield ProductsAPI.getTotalPriceProducts(items.map(item => ({
                colorId: item.colorId,
                productId: item.product.productId,
                skuId: Number(item.sku),
            })), servicesEndpoint, defaultRequestParams, mainWebshopId);
            setTotalPrice(data);
        }
        catch (_a) { }
    });
    useEffect(() => {
        if (isOpen && !shouldRender && !isPDP) {
            fetchProducts();
        }
    }, [isOpen]);
    useEffect(() => {
        if (Boolean(productIds === null || productIds === void 0 ? void 0 : productIds.length) && shouldRender && !isPDP) {
            setShouldRender(false);
            fetchProducts();
        }
    }, [productIds]);
    if (!shouldRender) {
        return null;
    }
    return (_jsx(MiniPDPMulti, { isOpen: isOpen, popoverTitle: popoverTitle, title: title, onClose: _onClose, products: isPDP ? productsInfo : products, extensiveCarouselImages: extensiveCarouselImages, wishlistProducts: wishlistProducts, onWishListToggle: onWishListToggle, onAddToBasket: onAddToBasket, fetchDeliveryPromise: fetchDeliveryPromise, fetchTotalPrice: fetchTotalPrice, deliveryPromise: deliveryPromise, totalPrice: totalPrice, cdnSettings: cdnSettings, isPDP: isPDP }));
};
export default MiniPDPMultiContainer;
